const commonView = () => import('@/views/website-management')
const LodingNumber = () => import('@/views/website-management/login-number.vue')
const addLodingNumber = () => import('@/views/website-management/add-login-number.vue')
const LoginNumberInside = () => import('@/views/website-management/login-number-inside.vue')
const AddLoginNumberInside = () => import('@/views/website-management/add-login-number-inside.vue')
const LoginNumberRelated = () => import('@/views/website-management/login-number-related.vue')
import acoutLeading from './acout'
export default {
  path: 'website-management',
  name: 'website-management',
  meta: { title: '网站管理', Submenu: true, menuOpenid: "16" },
  component: commonView,
  redirect: '/main/:GD/website-management/login-number',
  children: [
    acoutLeading,
    {
      path: 'login-number',
      name: 'login-number',
      meta: { title: '入口網站管理' },
      component: LodingNumber,
    },
    {
      path: 'add-login-number',
      name: 'add-login-number',
      meta: { title: '新增入口網站' },
      component: addLodingNumber,
    },
    {
      path: 'login-number-inside/:id',
      name: 'login-number-inside',
      meta: { title: '登入内页' },
      component: LoginNumberInside,
    },
    {
      path: 'add-login-number-inside/:id',
      name: 'add-login-number-inside',
      meta: { title: '新增内页' },
      component: AddLoginNumberInside,
    },
    {
      path: 'login-number-related',
      name: 'login-number-related',
      meta: { title: '登入页码相关设定' },
      component: LoginNumberRelated,
    }
  ]
}
